import Chart from "react-apexcharts";

const PieChart = (props) => {
  const { series, options } = props;

  return (
    <Chart
      options={options}
      type="pie"
      width="500px"
      height="100%"
      series={series}
    />
  );
};

export default PieChart;
